import Button from 'components/Button';
import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import Loading from '../../../../../components/Loading/index';
import { checkToken } from '../../../services/API';
import ChangePasswordForm from './ChangePasswordForm';

class ChangePassword extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    showInfoMessage: PropTypes.func.isRequired,
  };

  state = {
    error: false,
    loading: true,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.showModal && nextProps.showModal !== this.props.showModal) {
      const { token } = nextProps;
      // validate token
      checkToken({ token }).then((res) => this.setState({ loading: false, error: !res.isOk }));
    }
  }

  showInfoMessage = (text) => {
    const { showInfoMessage, onHideModal } = this.props;
    showInfoMessage(text);
    onHideModal();
  };

  render() {
    const { showModal, onHideModal, token } = this.props;
    const { loading, error } = this.state;

    const changePasswordPage = (
      <div>
        <h2>Восстановление пароля</h2>
        <ChangePasswordForm
          showInfoMessage={this.showInfoMessage}
          token={token}
          initialValues={{ token }}
        />
      </div>
    );

    const errorPage = (
      <div>
        <h2>Ошибка</h2>
        <p>
          Ссылка недействительна, так как Вы уже воспользовались данной ссылкой для восстановления
          пароля. Повторите процедуру восстановления пароля для получения новой ссылки
        </p>
        <Button onClick={this.props.onHideModal}>Закрыть</Button>
      </div>
    );

    return (
      <Modal type="large" onClose={onHideModal} showModal={showModal}>
        {loading ? <Loading /> : error ? errorPage : changePasswordPage}
      </Modal>
    );
  }
}

export default ChangePassword;
